import  React from 'react';
import {InputLabel, InputTextField} from "@App/Components";
import Language from "@Components/Language";
import {ButtonPassword} from "@Components/Form/ButtonPassword";
import {ThemeButton} from "@Components/Form/ThemeButton";
import {FieldValues, useForm} from "react-hook-form";
import InputCheckboxButton from '@Components/Form/InputCheckboxButton';
import {Link, router, usePage} from "@inertiajs/react";
import {LoginProps} from "@Pages/Auth/Login/LoginType";
import {ThemeButtonLink} from "@Components/Form/ThemeButtonLink";
import {IconFloatField} from "@Components/IconFloatField";

interface LoginFormProps {
  handleRecaptchaExecution: () => Promise<{ success: boolean; token?: string; message?: string }>;
  isUseReCaptcha: boolean;
}
function LoginForm(props: LoginFormProps) {
  const {settings} = usePage().props as LoginProps;
  const {primaryColor} = settings;
  const { handleRecaptchaExecution, isUseReCaptcha } = props;
  const {control, handleSubmit} = useForm();

  function checkArrayValue(arr: string[] | undefined) {
    return !!arr && arr?.includes('1');
  }
  const submit = async (validateState: FieldValues) => {
    let postToLogin: any = {
      ...validateState,
      remember: checkArrayValue(validateState?.remember) ?? false,
    };

    if (isUseReCaptcha) {
      const recaptchaResult = await handleRecaptchaExecution();

      if (!recaptchaResult.success) {
        return { success: false, message: 'Please complete the reCAPTCHA' };
      }
      postToLogin['g-recaptcha-response'] = recaptchaResult.token;
    }

    router.post(route('login'), postToLogin, {replace: true});
  };

  return (
    <form onSubmit={handleSubmit(submit)}>
      <div className="mb-4">
        <IconFloatField
          label='User Name'
          id='username'
          icon="pi-user"
        >
          <InputTextField
            control={control}
            dusk="username"
            placeholder={Language.get('Username')}
            name="username"
            errorTextClassName="errorTextError"
            pt={{
              root: {
                className: 'border-1 px-2 py-0 border-round-right w-full h-3rem',
              },
            }}
            validate={(value: string) =>
              value?.length >= 3 || Language.get('User Name must be at least 3 letters')
            }
          />
        </IconFloatField>
      </div>
      <IconFloatField
        label='Password'
        id='password'
        icon="pi-lock"
      >
        <ButtonPassword control={control}/>
      </IconFloatField>
      <div className="p-inputgroup mb-3 mt-2 flex justify-content-between align-items-center">
        <div className="field-checkbox">
          <InputCheckboxButton
            control={control}
            dusk="remember"
            name="remember"
            checkboxClassName="text-700"
            items={[
              {
                label: Language.get('Remember me'),
                value: '1',
              },
            ]}
          />
        </div>
        <Link
          href={route('password.email')}
          style={{color: primaryColor}}
          className="rounded-md text-sm underline focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
        >
          {Language.get('Forgot Password')}
        </Link>
      </div>
      <ThemeButton
        type="submit"
        data-dusk="login-button"
        className="text-white-alpha-90 text-center flex justify-content-center text-lg w-full h-3rem"
        style={{background: primaryColor}}
      >
        {Language.get('Login')}
      </ThemeButton>
    </form>
  );
}

export default LoginForm;
